/**
 * Whether a ProductDetails block renders the TI provider-page details (M6).
 * One predicate for `ProductDetailsBlock`'s dispatch and for the tier
 * pre-selection gate in `useTiTiers`, so the two cannot drift (CMS-2054).
 */
export const rendersTiProviderDetails = (block: {
  renderingMode?: string | null;
}): boolean => block.renderingMode === 'TI_PROVIDER';
